import { createContext } from 'react';
import isEqual from 'lodash/isEqual';
import { storageManager } from '../../utils/storageManager';
import { MultiSelectProviderState, MultiSelectProviderAPI, MultiSelectProviderDynamicState } from './types';

export const SET_CHANGED_ITEMS = 'SET_CHANGED_ITEMS';
export const SET_TEMP_CHANGED_ITEMS = 'SET_TEMP_CHANGED_ITEMS';
export const RESET_TEMP_SELECTED_ITEMS = 'RESET_TEMP_SELECTED_ITEMS';
export const SET_INITIAL_SELECTED_ITEMS = 'SET_INITIAL_SELECTED_ITEMS';
export const StateContext = createContext<MultiSelectProviderState>({} as MultiSelectProviderState);
export const DynamicStateContext = createContext<MultiSelectProviderDynamicState>(
	{} as MultiSelectProviderDynamicState,
);
export const DispatchContext = createContext<MultiSelectProviderAPI>({} as MultiSelectProviderAPI);

export const initReducerState = ({ key, subKey }) => {
	const selectedItems = storageManager.getSubItem(key, subKey);
	const normalizedSelectedItems = selectedItems === null ? [] : selectedItems;
	return {
		selectedItems: normalizedSelectedItems,
		tempSelectedItems: normalizedSelectedItems,
		initialSelectedItems: [],
	};
};

export const multiSelectProviderReducer = (state, action) => {
	switch (action.type) {
		case SET_CHANGED_ITEMS: {
			const { selectedItems, tempSelectedItems } = state;

			if (tempSelectedItems.length === 0 || isEqual(selectedItems, tempSelectedItems)) {
				return state;
			}

			return {
				...state,
				selectedItems: tempSelectedItems,
			};
		}

		case SET_TEMP_CHANGED_ITEMS: {
			const { id, visible, itemKeyName } = action.payload;
			const { tempSelectedItems } = state;
			const hasSetting = tempSelectedItems.find((i) => i[itemKeyName] === id);
			const newTempSelectedItems = hasSetting
				? tempSelectedItems.map((i) => ({
						...i,
						visible: i[itemKeyName] === id ? visible : i.visible,
				  }))
				: tempSelectedItems.concat({
						[itemKeyName]: id,
						visible,
				  });

			return {
				...state,
				tempSelectedItems: newTempSelectedItems,
			};
		}

		case SET_INITIAL_SELECTED_ITEMS: {
			const { initialSelectedItems, itemKeyName } = action.payload;
			const { selectedItems } = state;
			const filteredPrevSelectedItems = selectedItems.filter((selectedItem) => {
				const hasSetting = initialSelectedItems.find(
					(initialSelectedItem) => initialSelectedItem[itemKeyName] === selectedItem[itemKeyName],
				);

				return !hasSetting;
			});

			const newSelectedItems = [...filteredPrevSelectedItems, ...initialSelectedItems];

			if (isEqual(selectedItems, newSelectedItems)) {
				return state;
			}

			return {
				...state,
				selectedItems: newSelectedItems,
				tempSelectedItems: newSelectedItems,
				initialSelectedItems: newSelectedItems,
			};
		}

		case RESET_TEMP_SELECTED_ITEMS:
			return {
				...state,
				tempSelectedItems: state.selectedItems,
			};

		default: {
			return state;
		}
	}
};
